const DEFAULT_ANNOUNCE = [
  'wss://tracker.openwebtorrent.com',
  'wss://tracker.webtorrent.dev',
]

const DEFAULT_ICE_SERVERS = [
  {
    urls: [
      'stun:stun.l.google.com:19302',
      'stun:stun1.l.google.com:19302',
      'stun:stun2.l.google.com:19302',
      'stun:stun3.l.google.com:19302',
    ],
  },
]

function parseCsvEnv(value) {
  if (!value) {
    return []
  }

  return value
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean)
}

function getAnnounce() {
  const fromEnv = parseCsvEnv(process.env.VUE_APP_WEBRTC_ANNOUNCE)
  if (fromEnv.length) {
    return fromEnv
  }
  return DEFAULT_ANNOUNCE
}

function getIceServers() {
  const fromEnv = parseCsvEnv(process.env.VUE_APP_WEBRTC_STUN)
  if (fromEnv.length) {
    return [{ urls: fromEnv }]
  }

  return DEFAULT_ICE_SERVERS
}

module.exports = {
  announce: getAnnounce(),
  iceServers: getIceServers(),
}
